import { jsx as _jsx } from "react/jsx-runtime";
export const BehanceEmbed = ({ contentInfo }) => {
    const url = `https://www.behance.net/embed/project/${contentInfo.galleryId}?ilo0=1`;
    return (_jsx("iframe", { allowFullScreen: true, loading: "lazy", referrerPolicy: "strict-origin-when-cross-origin", src: url, style: {
            border: 'none',
            borderRadius: 8,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            height: 400,
            width: '100%',
        } }));
};
//# sourceMappingURL=BehanceEmbed.js.map